export default {
    infoData: {
        companyName: '',
        siteName: '',
        ledgerName: '',
        businessType: '',
        feeTaskType: '',
        amount: '',
        taxAmount: '',
        remark: '',
        supplierComfirmAmount: '',
        stationName: ''
    },
    tableDataItems: [
        {
            prop: 'orderCode',
            label: '业务单号',
            type: 'normal'
        },
        {
            prop: 'quantity',
            label: '实发数量',
            type: 'normal'
        },
        {
            prop: 'businessTime',
            label: '用户签收时间',
            type: 'normal'
        },
        {
            prop: 'engineerCode',
            label: '工程师编码',
            type: 'normal'
        },
        {
            prop: 'engineerName',
            label: '工程师名称',
            type: 'normal'
        },
        {
            prop: 'engineerFee',
            label: '工程师费用',
            type: 'normal'
        },
        {
            prop: 'netFee',
            label: '网点费用',
            type: 'normal'
        },
        {
            prop: 'amount',
            label: '总费用',
            type: 'normal'
        },
        {
            prop: 'supplierAmount',
            label: '供应商确认费用',
            type: 'normal'
        },
        {
            prop: 'supplierMsg',
            label: '供应商备注',
            type: 'normal'
        },
        {
            prop: 'replyMsg',
            label: '沟通回复',
            type: 'normal'
        }
    ],
    costTableDataItems: [
        {
            prop: 'feeName',
            label: '费用名称',
            type: 'normal',
            width: '100'
        },
        {
            prop: 'isEngineer',
            label: '是否工程师',
            type: 'normal',
            width: '100'
        },
        {
            prop: 'incrementIdentCN',
            label: '增值服务标识',
            type: 'normal',
            width: '100'
        },
        {
            prop: 'customerNo',
            label: '客户单号',
            width: '200',
            type: 'normal'
        },
        {
            prop: 'taskNo',
            label: '任务单号',
            width: '200',
            type: 'normal'
        },
        {
            prop: 'netDispatchNo',
            label: '网点发车单号',
            width: '220',
            type: 'normal'
        },
        {
            prop: 'customer',
            label: '客户',
            width: '180',
            type: 'normal'
        },
        {
            prop: 'singleVolume',
            label: '单台体积(m³)',
            width: '100',
            type: 'normal'
        },
        {
            prop: 'ingleGrossweight',
            label: '单位毛重(kg)',
            width: '100',
            type: 'normal'
        },
        {
            prop: 'volum',
            label: '体积(m³)',
            width: '80',
            type: 'normal'
        },
        {
            prop: 'weight',
            label: '重量(Kg)',
            width: '80',
            type: 'normal'
        },
        {
            prop: 'quantity',
            label: '数量',
            width: '80',
            type: 'normal'
        },
        {
            prop: 'netDispatchVolume',
            label: '网点发车单体积',
            width: '150',
            type: 'normal'
        },
        {
            prop: 'netDispatchTotalMileage',
            label: '网点发车单总里程',
            width: '150',
            type: 'normal'
        },
        {
            prop: 'commodityGroupCode',
            label: '商品分类编码',
            width: '150',
            type: 'normal'
        },
        {
            prop: 'commodityGroupName',
            label: '商品分类名称',
            width: '250',
            type: 'normal'
        },
        {
            prop: 'deliveryModeText',
            label: '配送方式',
            width: '100',
            type: 'normal'
        },
        {
            prop: 'customerCommodityCode',
            label: '客户商品编码',
            width: '120',
            type: 'normal'
        },
        {
            prop: 'commodityName',
            label: '商品名称',
            width: '80',
            type: 'normal'
        },
        // {
        //     prop: 'commodityGroupCode',
        //     label: '商品分类编码',
        //     width: '80',
        //     type: 'normal'
        // },
        // {
        //     prop: 'mileage',
        //     label: '商品分类名称',
        //     width: '120',
        //     type: 'normal'
        // },
        {
            prop: 'billingGroupFive',
            label: '计费组5',
            width: '150',
            type: 'normal'
        },
        {
            prop: 'billingGroupFiveName',
            label: '计费组5名称',
            width: '120',
            type: 'normal'
        },
        {
            prop: 'receivingCity',
            label: '收货市',
            width: '100',
            type: 'normal'
        },
        {
            prop: 'receivingCounty',
            label: '收货区县',
            width: '120',
            type: 'normal'
        },
        {
            prop: 'receivingStreet',
            label: '收货乡镇街道',
            width: '120',
            type: 'normal'
        },
        {
            prop: 'costExcludingTax',
            label: '不含税成本',
            width: '160',
            type: 'normal'
        },
        {
            prop: 'taxRate',
            label: '税率',
            width: '80',
            type: 'normal'
        },
        {
            prop: 'taxAmount',
            label: '税额',
            width: '120',
            type: 'normal'
        },
        {
            prop: 'costIncludingTax',
            label: '含税成本',
            width: '100',
            type: 'normal'
        }
    ]
};
